<template>
  <div>
    <h1>Origen de tarifas planas</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar origen"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <b-table
        show-empty
        stacked="md"
        :items="getAllSources"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        emptyFilteredText="No existen registros por mostrar"
        empty-text="No existen registros por mostrar">
        <template v-slot:cell(acciones)="row">
          <router-link size="sm" :to="{name:'editOrigin', params: row.item}" class="mr-1"><b-button class="btn-sm" variant="outline-warning">Editar</b-button></router-link>
          <b-button class="btn-sm" variant="outline-danger"  @click="showDeleteOriginModal(row.item)">Eliminar</b-button>
        </template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
        </b-col>
      </b-row>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getAllSources.loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { Modal } from 'ant-design-vue'
import headers from '@/config/headers.js'
const GET_ALL_SOURCES = gql`
  query getAllSources{
    getAllSources{
      id
      name
      createdBy
      geofence {
        id
        name
      }
    }
  }
`
const DELETE_SOURCE = gql`
mutation deleteSource($sourceId: Int){
  deleteSource(sourceId: $sourceId){
    success
    message
  }
}
`
export default {
  data() {
    return {
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Nombre del origen' },
        { key: 'createdBy', label: 'Creado por' },
        'acciones',
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      getAllSources: [],
    }
  },
  apollo: {
    getAllSources: {
      query: GET_ALL_SOURCES,
      result({ data }) {
        this.totalRows = data.getAllSources.length
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
  },
  methods: {
    deleteOrigin(origin) {
      this.$apollo.mutate({
        mutation: DELETE_SOURCE,
        variables: {
          sourceId: parseInt(origin.id),
        },
        context: headers(),
      })
        .then(data => {
          console.log(data)
          this.$apollo.queries.getAllSources.refetch()
        })
        .catch(error => {
          console.log(error)
        })
    },
    showDeleteOriginModal(origin) {
      Modal.confirm({
        title: `¿Estás seguro(a) que deseas eliminar el origen ${origin.name}?`,
        okText: 'Aceptar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.deleteOrigin(origin)
        },
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
